/* eslint-disable import/prefer-default-export */
export const MESSAGE_KEY_DELETE = 'MESSAGE_KEY_DELETE';
